// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"15d7cfcb","580":"38502809"}[chunkId] + ".chunk.js";
};